export default function(callback) {
  let observer = null;
  let collected = [];
  function init() {
    observer = new IntersectionObserver(callback, {
      threshold: 0
    });
    for (const el of collected) {
      observer.observe(el);
    }
    collected = [];
  }
  function observe(el) {
    if (observer) {
      observer.observe(el);
      return;
    }
    collected.push(el);
  }
  function unobserve(el) {
    if (observer) {
      observer.unobserve(el);
    }
  }
  return { observe, unobserve, init };
}
